module.exports = __webpack_public_path__ + "static/img/footlogo.add355f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/footlogo.png
// module id = jpaS
// module chunks = 1